
class Common {
  getKey() {
    var currentDT = "";
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var min = today.getMinutes();
    var ss = today.getSeconds();
    var hh = today.getHours();
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    currentDT = yyyy + "-" + mm + "-" + dd + "-" + hh + "-" + min + "-" + ss;
    return currentDT;
  }
  compareKey(myKey, app) {
    
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let harang = app.$CryptoJS.AES.decrypt("U2FsdGVkX19tNCdYY7aVJIohQzdgd0CqZYvO0ymy69c=", atob("WlpKTTIwMjI=")).toString(app.$CryptoJS.enc.Utf8)
    var ngaun = yyyy+harang+mm+harang+dd
    const passKey = app.$CryptoJS.AES.decrypt("U2FsdGVkX1/m2Lx/1MvyV1UPQFwSjLPtZfK/lN2FnEs=", atob("WlpKTTIwMjI=")).toString(app.$CryptoJS.enc.Utf8)
    
    var keyList = myKey.split(app.$CryptoJS.AES.decrypt("U2FsdGVkX1+TtuFg6gAgZd2lqvM0orkGPfAbpot0z9g=", atob("WlpKTTIwMjI=")).toString(app.$CryptoJS.enc.Utf8))
    console.log(passKey +"=="+ keyList[0] +"&&"+ keyList[1]+"=="+ngaun)
    if (passKey == keyList[0] && keyList[1]==ngaun) {
      const enc = app.$CryptoJS.AES.encrypt(myKey+":content", myKey).toString()
      localStorage.setItem("userInfo",myKey)
      localStorage.setItem("enc",enc)
      
      let izus = keyList[0].split("").reverse().join("");
      let suzi = keyList[0] + "" + izus
      return suzi
    } else {
      return ""
    }
  }

}

export default new Common();
